export default function isNumber(n: any) {
  return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
}
